export const useLogStore = defineStore("log", () => {
  const auditLogRef = ref(null);

  function openOrderAuditLog({ orderId }) {
    toValue(auditLogRef).openOrderAuditLog({ orderId });
  }

  function openExtractResultEnterAuditLog({ executeId }) {
    toValue(auditLogRef).openExtractResultEnterAuditLog({ executeId });
  }

  function openCrossUnionResultEnterAuditLog({ executeId }) {
    toValue(auditLogRef).openCrossUnionResultEnterAuditLog({ executeId });
  }

  function openOrderStoreAuditLog({ orderId }) {
    toValue(auditLogRef).openStoreAuditLog({ orderId });
  }

  function getAuditLogRef(instance) {
    auditLogRef.value = instance;
  }

  //  交联报告日志 组长 auditType=1 执行页面 , auditType=2 报告页面
  function openCrossUnionReportAuditLog({ reportId }, auditType) {
    toValue(auditLogRef).openCrossUnionResultMergedAuditLog({ reportId }, auditType);
  }

  //  提取报告日志 组长 auditType=1 执行页面 ,  auditType=2 报告页面
  function openExtractReportAuditLog({ reportId }, auditType) {
    toValue(auditLogRef).openExtractResultMergedAuditLog({ reportId }, auditType);
  }

  // 新增建库|测序执行审核
  function openBuildLibResultEnterAuditLog({ resultId }) {
    toValue(auditLogRef).openBuildLibResultEnterAuditLog({ resultId });
  }

  function openSequenceResultEnterAuditLog({ resultId }) {
    toValue(auditLogRef).openSequenceResultEnterAuditLog({ resultId });
  }

  // 新增建库|测序最终审核
  function openBuildLibResultMergedAuditLog({ resultId }) {
    toValue(auditLogRef).openBuildLibResultMergedAuditLog({ resultId });
  }

  function openSequenceResultMergedAuditLog({ resultId }) {
    toValue(auditLogRef).openSequenceResultMergedAuditLog({ resultId });
  }

  return {
    auditLog: {
      openOrderAuditLog,
      openOrderStoreAuditLog,
      openExtractResultEnterAuditLog,
      openCrossUnionResultEnterAuditLog,

      openCrossUnionReportAuditLog,
      openExtractReportAuditLog,

      getAuditLogRef,
      openBuildLibResultEnterAuditLog,
      openSequenceResultEnterAuditLog,
      openBuildLibResultMergedAuditLog,
      openSequenceResultMergedAuditLog
    }
  };
});

export default useLogStore;
